export const handleChangeDataOrderDetails = (name, value) => ({
    type: 'CHANGE_DATA_USER_ORDER_DETAILS', name, value
});